export const DEFAULT_DURATION = 150
